import { FC } from 'react';
import { FormFileUpload } from '../../../../lib/components';
import { ProfileForm, ProfileFormProps } from '../shared/profileForm';
import { useStore } from '../../../../hooks/useStore';
import { Box } from '@mui/material';

type Props = Omit<ProfileFormProps, 'children'>;

export const ProfilePictureForm: FC<Props> = (props) => {
  const { employeeStore } = useStore();

  return (
    <ProfileForm {...props}>
      <Box
        sx={{
          width: '100%',
          '& .MuiFormControl-root > .MuiBox-root': {
            height: '480px',
            '& > .MuiBox-root': {
              flexGrow: 1,
              height: '100%',
              paddingY: 'unset',
              '& > .MuiBox-root': {
                width: '100%',
                height: '100%'
              },
              '& > .MuiBox-root:last-of-type': {
                display: 'none'
              }
            }
          }
        }}
      >
        <FormFileUpload
          name="profile_picture"
          cropPhoto={true}
          options={{
            maxFiles: 1,
            accept: {
              'image/jpeg': ['.jpeg', '.jpg', '.jpe'],
              'image/png': ['.png']
            }
          }}
          initFiles={employeeStore.currentEmployee?.general_data?.profile_picture ?? undefined}
        />
      </Box>
    </ProfileForm>
  );
};
